import { AstroTransitionLink } from "@shared/ui/AstroTransitionLink"
import { useRouteShellContext } from "@shared/ui/routeShellContext"
import type { BackButtonProps } from "@site-types/components/backButton"
export function BackButton({ backPage }: BackButtonProps) {
  const { locale, currentPage } = useRouteShellContext()
  const destination = `/${locale}/${backPage || currentPage}`

  return (
    <AstroTransitionLink
      to={destination}
      data-testid="back-button"
      className="mx-auto inline-block bg-[var(--deep-blue)] px-[1em] py-[0.5em] text-[1.6em]"
    >
      <i className="fa-sharp fa-regular fa-arrow-left" />
    </AstroTransitionLink>
  )
}

export default BackButton
